import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowUp, faArrowDown } from "@fortawesome/free-solid-svg-icons";

export default ({
  setOrderBy,
  order_by,
  setTimelineCourses,
  setIsLoading,
  setPage,
  setStatusId,
  status_id,
}) => {
  const [filterOptions] = useState([
    {
      label: "All",
      key: null,
    },
    {
      label: "Completed",
      key: 1,
    },
    {
      label: "In Progress",
      key: 2,
    },
    {
      label: "Not Started",
      key: 3,
    },
  ]);

  const refreshTimeline = () => {
    setPage(1);
    setIsLoading(true);
    setTimelineCourses([]);
  };

  const orderFilter = () => {
    refreshTimeline();
    if (order_by === "newest") {
      return setOrderBy("oldest");
    }

    setOrderBy("newest");
  };

  const filterTimeline = (event) => {
    refreshTimeline();

    const value = event.target.value;
    
    // Handle "All" option (empty string or "null" string)
    if (value === "null" || value === "" || value === "All") {
      return setStatusId(null);
    }
    
    // Convert to number for numeric status IDs
    setStatusId(Number(value));
  };

  return (
    <div className="text-right" style={{ display: "flex" }}>
      <span className="sort-filter" onClick={orderFilter}>
        <span className="sortName">Sort by </span>
        {order_by === "newest" && (
          <FontAwesomeIcon icon={faArrowUp} className="ms-1 fas" />
        )}
        {order_by === "oldest" && (
          <FontAwesomeIcon icon={faArrowDown} className="ms-1 fas" />
        )}
      </span>
      <select
        onChange={filterTimeline}
        className="form-select d-inline-block"
        aria-label="Default select example"
        value={status_id || ""}
      >
        {filterOptions.map((options, key) => (
          <option key={key} value={options.key !== null ? options.key : ""}>
            {options.label}
          </option>
        ))}
      </select>
    </div>
  );
}; 